import { validarSesion } from "./Auth";
const config = require("../env.json")

export const obtenerActividadesFecha=async(actividadTerapeuticaId,token)=>{
   
    const url=config.REACT_APP_WEBAPI_URL+`/actividadesfecha/`+actividadTerapeuticaId;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const ingresarActividadFecha=async(actividad,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividadesfecha`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"POST",
            body:JSON.stringify(actividad)
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}
export const obtenerActividadFecha=async(actividadFechaId,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividadesfecha/id/`+actividadFechaId;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"GET"
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}

export const actualizarActividadFecha=async(actividadFecha,token)=>{
    const url=config.REACT_APP_WEBAPI_URL+`/actividadesfecha`;
    const resp=await fetch(url,
        {
            headers:{
                "Content-Type":"application/json",
                'x-token':token
            },
            method:"PUT",
            body:JSON.stringify(actividadFecha)
        }
        );
    validarSesion(resp.status)
    const {data}=await resp.json();
    return data;
}
